<template>
  <div class="panel-pages-container">
    <button
      v-has-permission="'show_generic_action'"
      v-if="show_generic_display == 1 && all.length > 0"
      class="btn btn-sm btn-generic"
      v-show="withGeneric"
      :class="{ filled: startGeneric }"
      @click="videoGenerique('debut')"
    >
      <i class="icon-movie-clap"></i>
    </button>
    <div class="button-navigation" :class="[{ active: hasScrollSlides }]">
      <button
        id="button-navigation-left"
        class="  button-navigation--left btn btn-sm"
        :disabled="!hasScrollSlides"
        @click="dragSlide($event, -1)"
      >
        <i class="fa fa-angle-left" aria-hidden="true"></i>
      </button>
    </div>
    <div id="div-draggable" class="slides-panel row">
      <VuePerfectScrollbar
        id="ps-slide-wrapper"
        class="scroll-area"
        ref="ps"
        :use-both-wheel-axes="true"
        @ps-scroll-x="removeSmoothing"
        @ps-scroll-y="removeSmoothing"
      >
        <div class="row__inner" @mousewheel="scrollHorizontally">
          <draggable
            id="draggable-wrapper"
            style="display: flex;"
            v-model="list"
            @end="reorder"
            @start="getList"
            :move="dragSlide"
          >
            <transition-group name="list-complete">
              <div
                v-for="(slide, index) in all"
                class="card-wrapper"
                :class="{ extended: slide.isExtended }"
                :key="'list-complete-' + index"
                :data-uid="slide.uid"
              >
                <div class="transition-icon-wrapper">
                  <b-button
                    v-b-modal.modal-center
                    v-show="show_transition && (index > 0 || startGeneric)"
                    class="transition-btn"
                    @click="addTransition(slide)"
                    :class="{ active: hasTransition(slide) }"
                  >
                    <i class="icon-transition"></i>
                  </b-button>
                  <b-button
                    v-show="show_video_intro"
                    @click="videoGenerique('intro', index)"
                    class="transition-btn"
                    :class="{ active: hasStartGeneric(slide) }"
                  >
                    <i class="icon-film-strip"></i>
                  </b-button>
                </div>
                <panel-card
                  :index="index"
                  :slide="slide"
                  :isSelected="slide.uid === currentSegment.uid"
                  :removable="all.length > 1"
                  :showVideoIntro="{}"
                  @selected="selectSegment(slide)"
                  @duplicated="handleDuplicateSegment(slide, index)"
                  @toggled="toggleSegmentCards(slide, index)"
                  @insertSegment="handleInsertSegment(index)"
                  :is-segment-card="true"
                >
                </panel-card>
                <div
                  class="inner-slides-wrapper"
                  :style="calculateWidth(slide)"
                  :class="{ extended: slide.isExtended }"
                >
                  <draggable
                    class="inner-slides-container"
                    :key="segmentKey"
                    id="nested-draggable-wrapper"
                    style="display: flex;"
                    @end="reorderSlides($event, index)"
                    v-model="lists[index]"
                  >
                    <div
                      class="slides-transitions-wrapper"
                      v-for="(slideScreen, i) in getScreens(slide)"
                      :key="i"
                    >
                      <!--<div class="transition-icon-wrapper-slide">-->
                      <!--<b-button-->
                      <!--v-b-modal.modal-center-->
                      <!--v-show="i > 0"-->
                      <!--class="transition-btn"-->
                      <!--@click="addTransitionSlide(slideScreen)"-->
                      <!--:class="{ active: hasTransitionSlide(slideScreen) }"-->
                      <!--&gt;-->
                      <!--<i class="icon-transition"></i>-->
                      <!--</b-button>-->
                      <!--</div>-->
                      <panel-card
                        :index="i"
                        :segment="slide"
                        :slide="slideScreen"
                        :isSelected="slideScreen.uid === currentSlide.uid"
                        @selected="selectSlide(slide, slideScreen)"
                        @duplicated="
                          handleDuplicateSlideInsideSegment(slide, slideScreen, index, i)
                        "
                      >
                      </panel-card>
                    </div>
                  </draggable>

                  <b-button
                    pill
                    type="button"
                    class="btn btn-sm add-segment-btn"
                    @click.stop="handleAppendSlide(index)"
                  >
                    {{ $t('button.ecran') }}
                  </b-button>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div class="button-navigation" :class="[{ active: hasScrollSlides }]">
      <button
        id="button-navigation-right"
        class=" button-navigation--right btn btn-sm"
        :disabled="!hasScrollSlides"
        @click="dragSlide($event, 1)"
      >
        <i class="fa fa-angle-right" aria-hidden="true"></i>
      </button>
    </div>
    <button
      v-has-permission="'show_generic_action'"
      v-if="show_generic_display == 1 && all.length > 0"
      class="btn btn-sm btn-generic"
      v-show="withGeneric"
      :class="{ filled: finishGeneric }"
      @click="videoGenerique('fin')"
    >
      <i class="icon-finish"></i>
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
import mixin from '../../mixins/Mixin.js';
import mixinEditors from '../../mixins/GrapesMixinEditors';
import mixinGrapesHelpers from '../../mixins/GrapesMixinHelpers';
import mixinTranslate from '../../mixins/GrapesMixinTranslate';
import GrapesMixinPanels from '../../mixins/GrapesMixinPanels';
import PanelCard from './PanelCard';
import HasPermission from '../../core/directives/HasPermission.js';

export default {
  mixins: [mixin, mixinEditors, mixinGrapesHelpers, GrapesMixinPanels, mixinTranslate],
  directives: {
    HasPermission,
  },

  data() {
    return {
      show_transition: true,
      segmentKey: 0,
      logoDebut: '',
      logoFin: '',
      list: [],
      lists: [],
      show_video_intro: true,
      show_generic_display: 0,
      oldValue: '',
      opened: true,
      withGeneric: true,
      currentId: null,
      title: '',
      idSelected: 0,
      typeAnimation: '',
      animation: '',
      scrollInterval: null,
      showScroll: false,
      isExtendedSlides: false,
    };
  },
  components: {
    draggable,
    PanelCard,
    VuePerfectScrollbar,
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  computed: {
    ...mapGetters({
      all: 'segments/getSelectedSegments',
      currentSlide: 'slides/getCurrent',
      currentSegment: 'segments/getCurrent',
      modal: 'grapes/getModal',
      paramsClient: 'getParamsClients',
      startGeneric: 'segments/getStartGeneric',
      finishGeneric: 'segments/getFinishGeneric',
      hasPermission: 'hasPermission',
    }),
    hasScrollSlides() {
      if (this.all.length > 0) {
        let count = this.all.length;
        let panelWidth = 0;
        let widthSlides = 0;
        let cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
          if (this.isExtendedSlides) {
            let extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        let panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },
  },
  watch: {
    all: {
      handler(all) {
        all.forEach((el, index) => {
          this.lists[index] = this.getScreens(el);
        });
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('slides', ['setCurrentSlide']),
    ...mapActions('segments', [
      'setCurrentSegment',
      'setIndexSegmentToAdd',
      'setLengthSegmentToAdd',
      'setIndexSlideToAdd',
      'duplicateSegment',
      'duplicateSlideInsideSegment',
      'updateSlideInsideSegment',
      'toggleExtendSegment',
      'reorderSegments',
      'reorderSlidesInsideSegment',
    ]),
    ...mapActions('common', ['setGenericThem', 'setOptionsThemeSelect']),
    setActiveScrollButtons() {
      if (this.all.length > 0) {
        let count = this.all.length;
        let panelWidth = 0;
        let widthSlides = 0;
        let cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
          if (this.isExtendedSlides) {
            let extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        let panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },
    isActiveScrollSlide(extended) {
      this.$nextTick(() => {
        let index = 0;
        let interval = setInterval(() => {
          index++;
          this.isExtendedSlides = extended;
          this.setActiveScrollButtons();
          if (extended || !extended) {
            clearInterval(interval);
          }
          if (index === 10) {
            clearInterval(interval);
          }
        }, 500);
      });
    },
    getScreens(segment) {
      return segment.screens.filter(s => {
        return (
          s.type.toLowerCase().indexOf('generic') + s.type.toLowerCase().indexOf('blank') === -2
        );
      });
    },
    hasStartGeneric(segment) {
      return segment.screens.some(s => s.type === 'startGeneric');
    },
    hasTransition(segment) {
      return (
        segment.screens[0].transition.in && segment.screens[0].transition.in !== 'no-transition-in'
      );
    },
    hasTransitionSlide(slide) {
      return slide.transition.in && slide.transition.in.length > 0;
    },
    selectSlide(segment, slide) {
      if (slide.uid === this.currentSlide.uid) {
        return;
      }
      const editor = grapesjsEMP.editors[0];
      const wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);
      setTimeout(() => {
        const lastSlide = {
          uid: this.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles'),
        };
        this.updateSlideInsideSegment(lastSlide);
        this.generateSlideThmbnail(this.currentSlide.uid);
        setTimeout(() => {
          //Set Current Screen
          this.setCurrentSlide(slide);
          //Set Current Segment by Screen
          this.setCurrentSegment(segment);
          this.removeToolbarCkeditor();
          this.$root.$emit('updateCanvasContent');
          this.setNoAutoplayVideo(editor);
          let videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(player => {
            this.setPausedVideo(player);
          });
          if (
            this.paramsClient.display_default_blocks &&
            Object.keys(this.paramsClient.display_default_blocks).length > 0 &&
            this.paramsClient.modules.show_list_block_action
          ) {
            const blocks = document.querySelector(
              '#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)',
            );
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    selectSegment(slide) {
      if (slide.uid === this.currentSegment.uid) {
        return;
      }

      const editor = grapesjsEMP.editors[0];
      const wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);
      setTimeout(() => {
        const lastSlide = {
          uid: this.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles'),
        };
        this.updateSlideInsideSegment(lastSlide);
        this.generateSlideThmbnail(this.currentSlide.uid);
        setTimeout(() => {
          this.setCurrentSlide(slide.screens.filter(s => s.type !== 'startGeneric')[0]);
          this.setCurrentSegment(slide);
          this.removeToolbarCkeditor();
          this.$root.$emit('updateCanvasContent');
          this.setNoAutoplayVideo(editor);
          let videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(player => {
            this.setPausedVideo(player);
          });
          if (
            this.paramsClient.display_default_blocks &&
            Object.keys(this.paramsClient.display_default_blocks).length > 0 &&
            this.paramsClient.modules.show_list_block_action
          ) {
            const blocks = document.querySelector(
              '#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)',
            );
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    handleDuplicateSegment(segment, index) {
      if (this.startGeneric) {
        index++;
      }

      const clone = this.getSegmentCloneThis(segment);
      segment = Object.assign({}, segment, clone);
      this.duplicateSegment({ segment, index });

      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    handleDuplicateSlideInsideSegment(segment, slide, segmentIndex, slideIndex) {
      if (this.startGeneric) {
        segmentIndex++;
      }
      if (this.hasStartGeneric(segment)) {
        slideIndex++;
      }
      if (this.currentSlide.uid === slide.uid) {
        const clone = this.getClone();
        slide = Object.assign({}, this.currentSlide, clone);
      }
      this.duplicateSlideInsideSegment({ slide, segmentIndex, slideIndex });

      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    toggleSegmentCards(slide, index) {
      this.toggleExtendSegment(slide);
      this.isActiveScrollSlide(slide.isExtended);
      this.segmentKey++;
    },
    calculateWidth(segment) {
      const count = this.getScreens(segment).length;
      return {
        width: (segment.isExtended ? count * 198 + 25 : 0) + 'px', //168+25:0
      };
    },
    addTransition(segment) {
      this.$emit('transitionSelected', Object.assign({}, segment.screens[0]));
    },

    addTransitionSlide(slide) {
      this.$emit('transitionSelected', Object.assign({}, slide));
    },
    videoGenerique(generic, index) {
      if (this.paramsClient.display_themes_elements != null) {
        // initialize idTheme in store for each type generic
        if (generic == 'fin' && this.paramsClient.display_themes_elements.conclusion) {
          this.setGenericThem(this.paramsClient.display_themes_elements.conclusion[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.conclusion);
        }
        if (generic == 'intro' && this.paramsClient.display_themes_elements.intro) {
          this.setGenericThem(this.paramsClient.display_themes_elements.intro[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.intro);
        }
        if (generic == 'debut' && this.paramsClient.display_themes_elements.generic) {
          this.setGenericThem(this.paramsClient.display_themes_elements.generic[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.generic);
        }
      } else this.setGenericThem(0);

      var self = this;
      var mdlDialog = document.querySelector('.gjs-mdl-dialog');
      eventHub.$emit('eventShowListVideo', true);
      eventHub.$emit('displayGenericListVideo', generic);
      var infoContainer = document.getElementById('list_videos');
      infoContainer.setAttribute('generic', generic);
      infoContainer.setAttribute('data-index', this.startGeneric ? index + 1 : index);
      infoContainer.style.display = 'block';
      self.translatePluginsTitle(null, 'add_generic_' + generic);
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    handleInsertSegment(index) {
      this.setIndexSegmentToAdd(index + 1);
      this.setLengthSegmentToAdd(this.all.length);
      this.showSlideListModal();
      this.removeToolbarCkeditor();
    },
    handleAppendSlide(index) {
      this.setIndexSlideToAdd(index);
      this.$root.$emit('bv::show::modal', 'segment-list-modal');
    },
    showSlideListModal() {
      if (document.getElementById('module-list')) {
        document.getElementById('module-list').style.display = 'block';
      }
      this.$root.$emit('bv::show::modal', 'slide-list-modal');
      eventHub.$emit('hideModalTitleSegment', true);
    },
    reorder(event) {
      this.reorderSegments(event);
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    reorderSlides(event, index) {
      this.reorderSlidesInsideSegment({ event, index });
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
  },
  created() {
    this.show_generic_display = localStorage.getItem('video_generique');
    this.$root.$on('show-list-video', val => {
      this.videoGenerique(val);
    });
  },
  mounted() {
    if (this.paramsClient.show_video_intro === '0') this.show_video_intro = false;
    else this.show_video_intro = this.permission.show_intro_video_action;
    this.show_transition = this.permission.show_transition;
    this.isActiveScrollSlide();
    this.$root.$on('updateScrollInterval', obj => {
      this.dragSlide(obj.event, obj.position);
    });
  },
};
</script>

<style lang="scss">
@import '../../scss/media-queries';
.panel-pages-container {
  .lds-circle {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: rgb(59, 151, 227);
    animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  @keyframes lds-circle {
    0%,
    100% {
      animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
    }
    0% {
      transform: rotateY(0deg);
    }
    50% {
      transform: rotateY(1800deg);
      animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
    }
    100% {
      transform: rotateY(3600deg);
    }
  }

  .drag-wrapper {
    display: flex;
    justify-content: center;
  }

  .list-complete-enter,
  .list-complete-leave-active {
    opacity: 0;
  }

  @keyframes nodeInserted {
    from {
      opacity: 0.2;
    }
    to {
      opacity: 0.8;
    }
  }

  .item-dropzone-area {
    height: 2rem;
    background: #888;
    opacity: 0.8;
    animation-duration: 0.5s;
    animation-name: nodeInserted;
  }
  .panel__devices {
    position: initial;
  }

  .list_page {
    height: 90%;
    overflow: overlay;
  }

  div span {
    display: flex;
    margin-bottom: -5px;
  }
  #div-draggable {
    overflow-x: auto;
    overflow-y: hidden;
    margin: 0 5px !important;
    flex-grow: 1;
  }
  .btn-delete-dep {
    font-size: 15px !important;
  }
  .button_screen {
    position: fixed;
    width: 260px;
    bottom: 0px;
    color: rgb(255, 255, 255);
    background-color: rgb(59, 151, 227);
    padding-bottom: 33px;
    border: none;
    font-size: 15px;
    left: 40px;
    -webkit-transition: all 0.15s ease 0s;
    transition: all 0.15s ease 0s;
  }

  .row__inner {
    margin: 0;
    padding-bottom: 5px;
    display: flex;
    transform: translateY(4px);
    .card-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      &.extended {
        .segment-card {
          .containerScreen.tile__img {
          }
        }
        .panel-card-wrapper.segment-card {
          padding-right: 10px;
          .add-segment-btn {
            visibility: visible;
            opacity: 0;
            pointer-events: none;
          }
        }
      }
    }
  }

  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #b2b2b2;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: #b2b2b2;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #b2b2b2;
  }
  .gjs-pn-views .gjs-pn-btn {
    width: 16% !important;
    min-width: 35px !important;
    border-bottom: 0 !important;
  }
  .gjs-pn-views-container .gjs-pn-btn {
    width: 16% !important;
    min-width: 35px !important;
    border-bottom: 0 !important;
  }
  .gjs-pn-buttons {
    display: inline !important;
  }
  #gjs-pn-commands .gjs-pn-buttons,
  .gjs-pn-commands .gjs-pn-buttons {
    display: none !important;
  }
  .gjs-pn-panel.gjs-pn-views {
    margin-right: -43px !important;
  }
  .gjs-pn-panel#gjs-pn-views-container,
  .gjs-pn-panel.gjs-pn-views-container {
    height: calc(100% - 210px) !important;
    bottom: 125px !important;
  }
  .gjs-asset-manager {
    display: flex;
    flex-direction: row;
    height: 400px;
    margin: 15px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .item-li {
    /*margin: 5px;*/
    color: #fff;
  }

  body.custom_body.swal2-height-auto {
    height: 100% !important;
  }
  .transition-icon {
    width: 1.2rem;
  }
  /* always present */
  .expand-transition {
    transition: all 0.3s ease;
    height: 30px;
    padding: 10px;
    background-color: #eee;
    overflow: hidden;
  }
  /* .expand-enter defines the starting state for entering */
  /* .expand-leave defines the ending state for leaving */
  .expand-enter,
  .expand-leave {
    height: 0;
    padding: 0 10px;
    opacity: 0;
  }
  .modal-active {
    display: block;
  }
  .transition-btn {
    border: none !important;
    padding: 0 !important;
    width: 30px !important;
    height: 30px !important;
    background-color: transparent !important;
    opacity: 0.6;
    margin: 0 10px 0 0 !important;
    color: #3c5875 !important;
    font-size: 1.6em !important;
    &.active {
      opacity: 1;
    }
  }
  .transition-btn:hover,
  .transition-btn:active,
  .transition-btn:focus {
    background-color: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }

  .add-new-screen {
    margin-top: 0px !important;
    width: 160px !important;
    height: 90px !important;
    margin: 0 10px !important;
    background: transparent !important;
    border: 1px dashed #2196f3;
    color: #2196f3;
    transition: 0.2s;
    i {
      font-size: 32px;
    }
    &:hover {
      background-color: #2196f3 !important;
      color: #ffffff;
    }
  }

  .scroll-area {
    padding: 12px 15px;
    margin-left: -10px;
  }
  .resize-elements {
    width: calc(100% - 230px) !important;
  }
  .transition-icon-wrapper {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .transition-icon-wrapper-slide {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .inner-slides-wrapper {
    height: 98px;
    width: 0;
    margin-bottom: -6px;
    transition: width 0.3s ease-in-out, padding 0.3s ease-in-out;
    overflow: hidden;
    position: relative;
    padding: 0;
    &:hover {
      .add-segment-btn {
        visibility: visible;
        opacity: 1;
      }
    }
    &.extended {
      padding: 2px;
    }
    .inner-slides-container {
      transform: translateY(0) scale(0.9);
      transform-origin: left;
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row;
      .slides-transitions-wrapper {
        display: flex;
        flex-direction: row;
        width: 100%;
      }
    }
    .add-segment-btn {
      position: absolute;
      padding: 3px !important;
      font-size: 1em !important;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      right: 0;
      top: 50%;
      visibility: hidden;
      opacity: 0;
      -webkit-transition: visibility 0.3s ease-in-out, opacity 0.3s ease-in-out;
      transition: visibility 0.3s ease-in-out, opacity 0.3s ease-in-out;
      margin-right: 2px !important;
      color: #ffffff !important;
      background-color: #25ad66 !important;
      border: none !important;
      border-radius: 12px !important;
    }
  }
  .button-navigation {
    border: 1px solid #939ea7 !important;
    margin: 12px 5px !important;
    border-radius: 5px;
    font-size: 32px;
    color: #939ea7;
    &--right,
    &--left {
      height: 100%;
    }
    i {
      color: #939ea7;
      width: 1em;
    }
    &.active {
      background-color: #ffffff !important;
      color: #2196f3 !important;
      border: 2px solid #2196f3 !important;
      i {
        background-color: #ffffff !important;
        color: #2196f3 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// PanelPages.vue?3241f334